export default "__VITE_ASSET__BXF_A8PH__"